import { useState } from 'react';

import { Button } from '../../../../cdl/Button/Button';
import { Modal } from '../../../../cdl/Modal/Modal';
import { translate } from '../../../../common/helpers/translate.helper';
import { IconPlus } from '../../../../common/icons/cdl/Plus';

import { CreateWebhookModalContent } from './CreateWebhookModalContent';

interface AddWebhookDestinationButtonProps {
    groupId: string;
}

export const CreateWebhookButton = ({ groupId }: AddWebhookDestinationButtonProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button LeadingIcon={IconPlus} onClick={() => setIsOpen(true)}>
                {translate('webhooks.addDestination')}
            </Button>
            <Modal isOpen={isOpen} dismissible={false} scrollable={false}>
                <CreateWebhookModalContent groupId={groupId} onDismiss={() => setIsOpen(false)} />
            </Modal>
        </>
    );
};
